import styled from 'styled-components';

const styles = styled.div`
    transition: all ease-in-out 0.2s;

    :hover {
        cursor: pointer;
        transform: scale(1.2);
        transition: all ease-in-out 0.2s;
    }
`;

export default styles;
